/**
 * 各服务接口url前缀，单体应用时不填
 */
export const serverName = {
  platform: {
    account: '',
    admin: '',
    hr: '',
    log: '',
    permission: '',
    component: '',
    tenant: ''
  }
}



// WEBPACK FOOTER //
// ./src/api/config.js